import $http from '@/libs/axios'

class UserAPIs {
  static async update(payload: any) {
    return (await $http.put('/users/profile/update', payload)).data
  }

  static async resendVerification() {
    return (await $http.post('/resend-verify-email')).data
  }

  public static async sendUtm(utm: any) {
    return (await $http.post('/users/utm', utm)).data
  }

  public static async updatePixels(pixels: any) {
    return (await $http.post('/users/pixels', { pixels })).data
  }

  public static async deleteAccount() {
    return (await $http.delete('/users/delete-account')).data
  }
}

export default UserAPIs
